/* eslint-disable max-lines */
/* eslint-disable sonarjs/no-duplicate-string */
// 9fbef606107a605d69c0edbcd8029e5d
import { getAPIConfig, getBrand, getLabelValue, isCanada } from '@tcp/core/src/utils';
import { BRAND_NAMES } from '@tcp/core/src/constants/pageTitle.constants';
import {
  getDynamicLabelValues,
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '@tcp/core/src/utils/labels/labelUtilty';
import { GlobalSeoLabels, GLOBAL_SEO_LABELS } from '@tcp/core/src/utils/labels/globalSEO.labels';
import PAGES from '../constants/pages.constants';
import { TWITTER_SITE_TAG, TWITTER_SITE_CARD_TYPE } from '../constants/brandSpecific.constants';
import urlConfig from './SEOCanonicalUrls.config';
import seoURL from './SEOlinks.config';
import {
  getImagesToDisplay,
  getMapSliceForColorProductId,
} from '../components/features/browse/ProductListing/molecules/ProductList/utils/productsCommonUtils';
import { getUpdatedCanonicalUrl } from '../utils/utils.web';

const globalSeoLabels = getLabelFromCopyOrFromTranslation(GLOBAL_SEO_LABELS, GlobalSeoLabels);

const TCP_BASE_URL = 'https://www.childrensplace.com';
const SNJ_BASE_URL = 'https://www.sugarandjade.com';
const GYM_BASE_URL = 'https://www.gymboree.com';
const PJP_BASE_URL = 'https://www.pjplace.com';
const CLEARANCE_BASE_URL = 'https://www.tcpmonstersale.com';
const OG_TYPE_WEBSITE = 'website';
const OG_TYPE_PRODUCT = 'product';
const GenericSeoPages = ['Home', 'Checkout', 'Account', 'Bag', 'StoreLocator'];
const STYLITICS_IMG_URL = 'https://content.stylitics.com/images/collage/';

const SEO_CONFIG = {
  canonical: TCP_BASE_URL,
  robots: {
    property: 'robots',
    content: 'index',
  },
  noRobots: {
    property: 'robots',
    content: 'noindex, nofollow',
  },
  viewport: {
    property: 'viewport',
    content: 'user-scalable=no, initial-scale=1, maximum-scale=1, minimum-scale=1',
  },
  keywords: {
    property: 'keywords',
    content: 'childrensplace',
  },
  TCP: {
    twitter: {
      cardType: 'summary',
      site: '@childrensplace',
    },
    openGraph: {
      url: TCP_BASE_URL,
      title: 'Open Graph Title',
      description: 'Open Graph Description',
    },
    hrefLangs: [
      {
        id: 'us-en',
        canonicalUrl: TCP_BASE_URL,
      },
    ],
    OTHER: {
      title: " | The Children's Place",
      description: '',
    },
  },
  SNJ: {
    // BRAND-SPECIFIC-TODO
    twitter: {
      cardType: 'summary',
      site: '@childrensplace',
    },
    openGraph: {
      url: SNJ_BASE_URL,
      title: 'Open SNJ Graph Title',
      description: 'Open SNJ Graph Description',
    },
    hrefLangs: [
      {
        id: 'us-en',
        canonicalUrl: SNJ_BASE_URL,
      },
    ],
    OTHER: {
      title: " | The Children's Place",
      description: '',
    },
  },
  GYM: {
    twitter: {
      cardType: 'summary',
      site: '@Gymboree',
    },
    openGraph: {
      url: GYM_BASE_URL,
      title: 'Open Graph Title',
      description: 'Open Graph Description',
    },
    hrefLangs: [
      {
        id: 'us-en',
        canonicalUrl: GYM_BASE_URL,
      },
    ],
    OTHER: {
      title: ' | Gymboree',
      description: '',
    },
  },
  PJP: {
    twitter: {
      cardType: 'summary',
      site: '@Gymboree', // PJP-TODo
    },
    openGraph: {
      url: PJP_BASE_URL,
      title: 'Open Graph Titles', // PJP-TODo
      description: 'Open Graph Descriptions', // PJP-TODo
    },
    hrefLangs: [
      {
        id: 'us-en',
        canonicalUrl: PJP_BASE_URL,
      },
    ],
    OTHER: {
      title: ' | PJP',
      description: '',
    },
  },
  CLEARANCE: {
    twitter: {
      cardType: 'summary',
      site: '@tcpmonstersale',
    },
    openGraph: {
      url: CLEARANCE_BASE_URL,
      title: 'Open Graph Title',
      description: 'Open Graph Description',
    },
    hrefLangs: [
      {
        id: 'us-en',
        canonicalUrl: CLEARANCE_BASE_URL,
      },
    ],
    OTHER: {
      title: ' | TCP Monster Sale',
      description: '',
    },
  },
};

function getBrandDetails() {
  const { brandId, reqHostname: hostname, siteId } = getAPIConfig();
  const brand = brandId && brandId.toUpperCase();
  const BASE_URL = `https://${hostname}`;

  const BRAND_SITE = siteId;
  const BRAND_NAME = brand;
  const BRAND_BASE_URL = BASE_URL;
  const assetHost = getAPIConfig()[`assetHost${brand}`];
  const BRAND_LOGO_URL = `${assetHost}/w_1200,f_auto,q_auto,bo_200px_solid_rgb:afcee900/ecom/assets/static/images/favicon-${brandId}-cloud.png`;
  const BRAND_TWITTER_SITE_TAG = TWITTER_SITE_TAG[brand];
  const BRAND_TWITTER_SITE_CARD_TYPE = TWITTER_SITE_CARD_TYPE[brand];
  const BRAND_DEFAULT_TITLE_VAL = SEO_CONFIG[brand].OTHER.title;
  const BRAND_DEFAULT_DESCRIPTION_VAL = SEO_CONFIG[brand].OTHER.description;

  return {
    BRAND_NAME,
    BRAND_BASE_URL,
    BRAND_TWITTER_SITE_TAG,
    BRAND_TWITTER_SITE_CARD_TYPE,
    BRAND_DEFAULT_TITLE_VAL,
    BRAND_DEFAULT_DESCRIPTION_VAL,
    BRAND_LOGO_URL,
    BRAND_SITE,
  };
}

const getAdditionalMetaTags = (property, content) => ({
  property,
  content,
});

const getOpenGraph = ({
  ogUrl,
  categoryUrl,
  ogTitle,
  pageTitle,
  ogDescription,
  description,
  ogType,
  ogImage,
  brandDetails,
}) => ({
  url: ogUrl || categoryUrl,
  title: ogTitle || pageTitle,
  description: ogDescription || description,
  type: ogType || OG_TYPE_WEBSITE,
  images: [{ url: ogImage || brandDetails.BRAND_LOGO_URL }],
});

const getMetaSEOTags = ({
  title,
  description,
  canonical,
  twitter,
  openGraph,
  hrefLangs,
  keywords,
  path,
}) => {
  const brandDetails = getBrandDetails();
  const { originalPath } = getAPIConfig();

  const noindex =
    path === PAGES.OUTFIT.toLowerCase() ||
    path === PAGES.SEARCH_PAGE.toLowerCase() ||
    path === PAGES.BAG.toLowerCase();
  const nofollow = noindex;
  return {
    title,
    description,
    canonical: canonical || brandDetails.BRAND_BASE_URL + originalPath,
    twitter,
    openGraph,
    hrefLangs,
    noindex,
    nofollow,
    additionalMetaTags: [
      getAdditionalMetaTags(SEO_CONFIG.keywords.property, keywords),
      // Viewport has been coded in _document file, as it was not being applied for mobile
      // getAdditionalMetaTags(SEO_CONFIG.viewport.property, SEO_CONFIG.viewport.content),
    ],
  };
};

export const getPlpSeoTags = (
  getSeoMap,
  categoryKey,
  cid,
  imageURL,
  isNewSEOHreflangLinkEnabled,
  seoTokenList
) => {
  const brandDetails = getBrandDetails();
  const { seoTitle = '', seoMetaDesc = '', canonicalUrl = '' } = getSeoMap;

  const title = seoTitle;
  const description = seoMetaDesc;

  const apiConfigObj = getAPIConfig();
  const brandName = getBrand();
  const brandId = brandName && brandName.toUpperCase();
  const assetHost = apiConfigObj[`assetHost${brandId}`];
  const productAssetPath = apiConfigObj[`productAssetPath${brandId}`];
  let tempUrl = '';
  if (imageURL?.indexOf('https://') > -1) {
    tempUrl = imageURL;
  } else if (imageURL?.indexOf('/content/') > -1) {
    tempUrl = imageURL && `${assetHost}/w_200${imageURL}`;
  } else {
    tempUrl = imageURL && `${assetHost}/w_200/${productAssetPath}/${imageURL}`;
  }
  const fullImageURL = tempUrl;

  const openGraph = {
    url: `${brandDetails.BRAND_BASE_URL}${categoryKey}`,
    title,
    description,
    type: OG_TYPE_WEBSITE,
    images: [{ url: fullImageURL || brandDetails.BRAND_LOGO_URL }],
  };

  const twitter = {
    cardType: `${brandDetails.BRAND_TWITTER_SITE_CARD_TYPE}`,
    site: `${brandDetails.BRAND_TWITTER_SITE_TAG}`,
  };

  let canonical;
  const catUrl =
    categoryKey.indexOf('?') > 1 ? categoryKey.split('?')[0] : categoryKey.split('#')[0];
  canonical = `${brandDetails.BRAND_BASE_URL}${catUrl}`;
  canonical = getUpdatedCanonicalUrl(canonicalUrl, canonical);

  let hrefLangs;
  if (isNewSEOHreflangLinkEnabled && seoTokenList) {
    hrefLangs = seoURL({
      brand: brandDetails.BRAND_NAME,
      path: canonical,
      withCountry: false,
      seoTokenList,
    });
  } else {
    hrefLangs = urlConfig({
      brand: brandDetails.BRAND_NAME,
      path: canonical,
      withCountry: false,
    });
  }

  return getMetaSEOTags({
    title,
    description,
    canonical,
    twitter,
    openGraph,
    hrefLangs,
    keywords: SEO_CONFIG.keywords.content,
  });
};

// For account, bag and checkout, graphQL call has been removed for seo and are now being managed by labels
export const getSEOTags = ({ SEOData, labels, path, contentType, router, brand }) => {
  let {
    pageTitle,
    description,
    canonicalUrl,
    keywords,
    twitterCard,
    twitterSite,
    ogTitle,
    ogUrl,
    ogType,
    ogDescription,
    ogImage,
  } = SEOData[path] || SEOData[contentType] || {};
  const { robotsInfo } = SEOData[path] || SEOData[contentType] || {};
  if (
    path === PAGES.BAG ||
    path === PAGES.CHECKOUT_PAGE ||
    path === PAGES.ACCOUNT_PAGE.toLowerCase()
  ) {
    pageTitle = renderLabel(
      globalSeoLabels[`lbl_${path}_${brand}_pageTitle`],
      `lbl_${path}_${brand}_pageTitle`
    );
    description = renderLabel(
      globalSeoLabels[`lbl_${path}_${brand}_description`],
      `lbl_${path}_${brand}_description`
    );
    canonicalUrl = getLabelValue(labels, `lbl_${path}_ canonicalUrl`, 'seo', 'global', true);
    keywords = getLabelValue(labels, `lbl_${path}_keywords`, 'seo', 'global', true);
    twitterCard = getLabelValue(labels, `lbl_${path}_twitterCard`, 'seo', 'global', true);
    twitterSite = getLabelValue(labels, `lbl_${path}_twitterSite`, 'seo', 'global', true);
    ogTitle = getLabelValue(labels, `lbl_${path}_ogTitle`, 'seo', 'global', true);
    ogUrl = getLabelValue(labels, `lbl_${path}_ogUrl`, 'seo', 'global', true);
    ogType = getLabelValue(labels, `lbl_${path}_ogType`, 'seo', 'global', true);
    ogDescription = getLabelValue(labels, `lbl_${path}_ogDescription`, 'seo', 'global', true);
    ogImage = getLabelValue(labels, `lbl_${path}_ogImage`, 'seo', 'global', true);
  }
  if (path === PAGES.OUTFIT) {
    const outfitId = router && router.query && router.query.outfitId;
    ogImage = `${STYLITICS_IMG_URL}${outfitId}/xl.jpg`;
  }

  return {
    pageTitle,
    description,
    canonicalUrl,
    keywords,
    twitterCard,
    twitterSite,
    ogTitle,
    ogUrl,
    ogType,
    ogDescription,
    ogImage,
    robotsInfo,
  };
};

const getGenericSeoTags = (store, router, categoryKey, path = 'home') => {
  const brandDetails = getBrandDetails();
  const { brandId } = getAPIConfig();
  const brand = brandId.toUpperCase();
  const { SEOData } = store.getState();
  const { contentType } = (router && router.query) || {};
  const { Labels: labels } = store.getState();
  const tags = getSEOTags({ SEOData, labels, path, contentType, router, brand });
  const {
    pageTitle = '',
    description = '',
    canonicalUrl = '',
    keywords,
    twitterCard = '',
    twitterSite = '',
    ogTitle = '',
    ogUrl = '',
    ogType = '',
    ogDescription = '',
    ogImage = '',
    robotsInfo = '',
  } = tags || {};
  const extractcurrentPath = categoryKey.includes('?')
    ? categoryKey.split('?')[0]
    : categoryKey.split('#')[0];
  const pathUrl = extractcurrentPath.replace(/^(.+?)\/*?$/, '$1');
  const categoryUrl = `${brandDetails.BRAND_BASE_URL}${pathUrl}`;
  const openGraph = getOpenGraph({
    ogUrl,
    categoryUrl,
    ogTitle,
    pageTitle,
    ogDescription,
    description,
    ogType,
    ogImage,
    brandDetails,
    robotsInfo,
  });

  const canonicalUrlConfig = {
    brand,
    path: path === PAGES.CONTENT ? `${path}/${contentType}` : categoryUrl,
  };
  const hrefLangs = urlConfig(canonicalUrlConfig);
  const twitter = {
    cardType: twitterCard || `${brandDetails.BRAND_TWITTER_SITE_CARD_TYPE}`,
    site: twitterSite || `${brandDetails.BRAND_TWITTER_SITE_TAG}`,
  };
  return getMetaSEOTags({
    title: pageTitle,
    description,
    canonical: canonicalUrl || categoryUrl,
    twitter,
    openGraph,
    hrefLangs,
    keywords,
    robots: robotsInfo || SEO_CONFIG.robots.content,
    path,
  });
};

const getPdpLabels = () => {
  return {
    pdpSeoDesc: getDynamicLabelValues('dynamic.browse_d.lbl_pdp_SEO_desc'),
  };
};

const getPdpDescription = (
  isBundleProduct,
  labels,
  descriptionDynamicContent,
  productLongDescription
) => {
  let description;
  if (!isBundleProduct) {
    const pdpLabels = getPdpLabels();
    const { pdpSeoDesc } = pdpLabels;
    const descriptionFinalContent =
      pdpSeoDesc && pdpSeoDesc.replace('$1', `${descriptionDynamicContent}`);
    description = !pdpSeoDesc ? `${productLongDescription}` : `${descriptionFinalContent}`;
  } else {
    description = `${productLongDescription}`;
  }
  return description;
};

// Replaced color.name with color.family to get the better seo as per the ticket - DRP-70145.
// If color family is not present then colorName will be returned.
const getPdpColorName = (productInfo) => {
  const { generalProductId, colorFitsSizesMap = [] } = productInfo;
  const colorName = colorFitsSizesMap.filter((res) => res.colorDisplayId === generalProductId);
  return colorName?.[0]?.color?.family || colorName?.[0]?.color?.name;
};

export const getPdpSeoTags = (productInfo = {}, router, categoryKey, labels, isBundleProduct) => {
  const brandDetails = getBrandDetails();

  const catUrl =
    categoryKey.indexOf('?') > 1 ? categoryKey.split('?')[0] : categoryKey.split('#')[0];

  const twitter = {
    cardType: `${brandDetails.BRAND_TWITTER_SITE_CARD_TYPE}`,
    site: `${brandDetails.BRAND_TWITTER_SITE_TAG}`,
  };

  const canonical = `${brandDetails.BRAND_BASE_URL}${catUrl}`;

  const hrefLangs = urlConfig({
    brand: brandDetails.BRAND_NAME,
    path: canonical,
    withCountry: false,
  });

  const brand = getBrand();
  const productName = productInfo.name;
  const longProductTitle = productInfo.long_product_title;
  const productLongDescription = productInfo.product_long_description;
  const productTitle = longProductTitle || productName;
  const colorName = getPdpColorName(productInfo);
  const productTitleWithClr =
    productTitle && colorName ? `${productTitle} - ${colorName}` : productTitle;

  const tcpTitle = `${BRAND_NAMES[brand]} ${isCanada() ? 'CA' : ''}`;
  const title = productTitleWithClr ? `${productTitleWithClr} | ${tcpTitle}` : productTitleWithClr;
  const descriptionDynamicContent = `${productName} - ${colorName}`;
  const description = getPdpDescription(
    isBundleProduct,
    labels,
    descriptionDynamicContent,
    productLongDescription
  );

  let imagesToDisplay = [];
  if (productInfo && productInfo.imagesByColor) {
    const { colorFitsSizesMap, generalProductId, imagesByColor } = productInfo;
    imagesToDisplay = getImagesToDisplay({
      imagesByColor,
      curentColorEntry: getMapSliceForColorProductId(colorFitsSizesMap, generalProductId) || {},
      isAbTestActive: false,
      isFullSet: true,
    });
  }
  const brandName = getBrand();
  const brandId = brandName && brandName.toUpperCase();
  const apiConfigObj = getAPIConfig();
  const assetHost = apiConfigObj[`assetHost${brandId}`];
  const productAssetPath = apiConfigObj[`productAssetPath${brandId}`];

  const openGraph = {
    url: `${brandDetails.BRAND_BASE_URL}${categoryKey}`,
    title,
    description,
    type: OG_TYPE_PRODUCT,
    images: imagesToDisplay.map(({ regularSizeImageUrl }) => ({
      url: `${assetHost}/w_200/${productAssetPath}/${regularSizeImageUrl}`,
    })),
  };

  return getMetaSEOTags({
    title,
    description,
    canonical,
    twitter,
    openGraph,
    hrefLangs,
    keywords: SEO_CONFIG.keywords.content,
    robots: SEO_CONFIG.robots.content,
  });
};

export const deriveSEOTags = (
  pageId,
  store,
  router,
  imageURL,
  isNewSEOHreflangLinkEnabled,
  seoTokenList
) => {
  const asPath = router && router.asPath;
  // Please Note: Convert into switch case if you are adding more cases in this method.
  if (GenericSeoPages.indexOf(pageId) !== -1) {
    const categoryKey = asPath;
    return getGenericSeoTags(store, router, categoryKey, pageId.toLowerCase());
  }
  if (pageId === PAGES.PRODUCT_LISTING_PAGE || pageId === PAGES.NEW_PRODUCT_LISTING_PAGE) {
    const categoryKey = asPath;
    const { cid } = router.query;
    const getSeoMap = store; // We are passing the SeoMap value as the second parameter
    return getPlpSeoTags(
      getSeoMap,
      categoryKey,
      cid,
      imageURL,
      isNewSEOHreflangLinkEnabled,
      seoTokenList
    );
  }
  if (pageId === PAGES.SEARCH_PAGE || pageId === PAGES.OUTFIT) {
    return getGenericSeoTags(store, router, asPath, pageId.toLowerCase());
  }
  if (pageId === PAGES.STORE) {
    return getGenericSeoTags(store, router, asPath, pageId.toLowerCase());
  }
  if (pageId === PAGES.PRODUCT_DESCRIPTION_PAGE) {
    let isBundleProduct = false;
    if (pageId === PAGES.BUNDLED_PRODUCT_DESCRIPTION_PAGE) {
      isBundleProduct = true;
    }
    const categoryKey = asPath;
    return getPdpSeoTags(store.productInfo, router, categoryKey, store.labels, isBundleProduct);
  }
  if (pageId === PAGES.STORELOCATOR) {
    const categoryKey = asPath;
    return getGenericSeoTags(store, router, categoryKey, PAGES.STOREPATH);
  }
  return getGenericSeoTags(store, router, asPath, pageId.toLowerCase());
};

export default {
  deriveSEOTags,
};
